import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";

const OnlineCardsSalesOverview = ({ data }) => {
  const {
    online_card_sales_would_you_like_i2c_c_cart,
    online_card_sales_i2c_c_card_language,
    online_card_sales_i2c_c_card_language_other,
  } = data["3_2"];

  const languageValue = [
    ...(online_card_sales_i2c_c_card_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(online_card_sales_i2c_c_card_language?.includes("other") &&
    online_card_sales_i2c_c_card_language_other?.length
      ? [`Other (${toTitleCase(online_card_sales_i2c_c_card_language_other)})`]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <ReviewSummarySectionHeading title="Online Card Sales / Self Service Enrollment (C-Cart)" />
        </div>
        <ReviewAttribute
          label="Would you like i2c C-Cart?"
          value={
            online_card_sales_would_you_like_i2c_c_cart?.length
              ? toTitleCase(online_card_sales_would_you_like_i2c_c_cart)
              : "-"
          }
        />
        <ReviewAttribute label="C-Cart Language" value={languageValue || "-"} />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default OnlineCardsSalesOverview;
